export const UserTypes = Object.freeze({
    Business: 'Business',
    Personal: 'Personal',
    Beneficiary: 'Beneficiary',
})

export const AccountTypes = Object.freeze({
    Paid: 'Paid',
    Subscriber: 'Subscribed',
})

export const CourseTypes = Object.freeze({
    Free_For_All: `Free_For_All`,
    Free_For_Subscribers: `Free_For_Subscribers`,
    Classic: `Classic`,
    Premium: `Premium`,
})
